import { Snackbar, useMediaQuery, Alert } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useContext, useCallback } from 'react';
import StoreContext from 'stores/context/StoreContext';
import type { SnackbarCloseReason, SnackbarOrigin } from '@mui/material';

const Notify = observer((): JSX.Element => {
  const { notifyStore } = useContext(StoreContext);
  const isTouchDevice = useMediaQuery('(hover: none)');

  const anchorOrigin: SnackbarOrigin | undefined = isTouchDevice
    ? { horizontal: 'center', vertical: 'top' }
    : undefined;

  const handleClose = useCallback(
    (_e: unknown, reason?: SnackbarCloseReason): void => {
      // eslint-disable-next-line @cspell/spellchecker
      // Не закрываем уведомление при клике вне области (MUI clickaway event)
      // eslint-disable-next-line @cspell/spellchecker
      if (reason === 'clickaway') {
        return;
      }
      notifyStore.closeNotify();
    },
    [notifyStore]
  );

  const handleExited = useCallback((): void => {
    // Полностью очищаем уведомление после завершения анимации закрытия
    notifyStore.clearNotify();
  }, [notifyStore]);

  if (!notifyStore.notify) {
    return <></>;
  }

  return (
    <Snackbar
      open={Boolean(notifyStore.notify.open)}
      anchorOrigin={anchorOrigin}
      autoHideDuration={10000}
      onClose={handleClose}
      disableWindowBlurListener
      slotProps={{
        transition: {
          onExited: handleExited,
        },
      }}
      // Добавляем ключ для принудительного пересоздания при смене сообщения
      key={`${notifyStore.notify.message}-${notifyStore.notify.severity}`}>
      <Alert
        elevation={6}
        variant='filled'
        severity={notifyStore.notify.severity}
        onClose={handleClose}
        sx={{ width: '100%' }}>
        {notifyStore.notify.message}
      </Alert>
    </Snackbar>
  );
});

export default Notify;
